export const STORAGE_CONSTRAINT = {
  USER_SESSION: "USER_SESSION",
  LANG: "i18nextLng",
};
